import 'select2';
import 'select2/dist/css/select2';
import { Controller } from "stimulus"
import Swal from 'sweetalert2';

export default class extends Controller {
  static targets = ['form'];

  scheduleClass() {
    this.askQuestion('Para agendar essa aula, será consumido 1 (um) crédito do contrato selecionado. Deseja continuar?').then(async (result) => {
			if (!result.value)
				return;

      this.fetchSelectedSchedule();
      this.formTarget.submit();
    });
  }

  askQuestion(question) {
		return Swal.fire({
			html: question,
			showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText: 'Continuar',
			cancelButtonText: 'Cancelar',
		});
	}

  fetchSelectedSchedule() {
    let identifier = 'calendar-pick-schedule',
      controller = document.querySelector(`[data-controller="${identifier}"]`)[identifier];

    this.element.querySelector('.new-attendance-attributes').innerHTML = controller.getSelectedSchedules().map((node) => node.outerHTML).join('');
    $(this.$modalSchedule).modal('hide');
  }
}
